import NavBar from '../components/navbar/navBar';
import ExperienceSection from '../components/experienceSection'
import Footer from '../components/footer';

const ExperiencePage = () => {
    return (
        <>
            <NavBar/>
            <ExperienceSection/>
            <Footer/>
        </>
    );
}

export default ExperiencePage;
